import {createEvent, sample} from "effector";

export const toggleShowSuccessEv = createEvent()

